import { IFields } from '../interfaces';

export const USER_FIELDS: IFields = {
  email: {
    fields: [
      {
        title: 'Адрес электронной почты',
        name: 'email',
      },
      {
        title: 'Код',
        name: 'code',
      },
    ],
  },
  photo: {
    fields: [
      {
        title: 'Фотография',
        name: 'photo',
      },
    ],
  },
  personalInfo: {
    fields: [
      {
        title: 'Имя',
        name: 'fullName',
        children: [
          {
            title: 'Фамилия',
            name: 'lastName',
          },
          {
            title: 'Имя',
            name: 'firstName',
          },
          {
            title: 'Отчество',
            name: 'middleName',
          },
        ],
      },
      {
        title: 'Регион проживания',
        name: 'region',
      },
      {
        title: 'Дата рождения',
        name: 'birth_date',
      },
    ],
  },
  password: {
    fields: [
      {
        title: 'Пароль',
        name: 'password',
      },
      {
        title: 'Повторите пароль',
        name: 'repeatPassword',
      },
    ],
  },
} as const;

